import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import AccessPointConnectionBody from './AccessPointConnectionBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC, VICE_PRESIDENT_FSE } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import { AccessPointConnectionProvider } from './context/AccessPointConnectionContext';

const AccessPointConnection = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <AccessPointConnectionProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Access Point connection" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <AccessPointConnectionBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </AccessPointConnectionProvider>
    </div>
  );
};

export default AccessPointConnection;
